import { render, staticRenderFns } from "./ConfigAlert.vue?vue&type=template&id=42d0a20d&scoped=true&"
import script from "./ConfigAlert.vue?vue&type=script&lang=js&"
export * from "./ConfigAlert.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAlert.vue?vue&type=style&index=0&id=42d0a20d&prod&lang=scss&scoped=true&"
import style1 from "./ConfigAlert.vue?vue&type=style&index=1&id=42d0a20d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d0a20d",
  null
  
)

export default component.exports